import { render, staticRenderFns } from "./simTem.vue?vue&type=template&id=fb28c7fe"
import script from "./simTem.vue?vue&type=script&lang=js"
export * from "./simTem.vue?vue&type=script&lang=js"
import style0 from "./simTem.vue?vue&type=style&index=0&id=fb28c7fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports